import apiConfig from './apiConfig';
import configuration from '../../../../configuration.json';

const hostname = window?.location?.hostname;
const apiURLs = apiConfig.setEnvironmentURLs(hostname);

export const IDENTITY_CONFIG = {
    authority: apiURLs.authorityOIDC, //(string): The URL of the OIDC provider.
    response_type: "code", //(string, default: 'id_token' --> code): The type of response desired from the OIDC provider.
    client_id: apiURLs.clientID, //(string): Your client application's identifier as registered with the OIDC provider.
    scope: "openid B2E-full", //(string, default: 'openid'): The scope being requested from the OIDC provider.
    redirect_uri: apiURLs.redirectURI, //The URI of your client application to receive a response from the OIDC provider.
    automaticSilentRenew: false, //(boolean, default: false): Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration.
    loadUserInfo: false, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
   // grantType: "password", // "authorization_code, client_credentials, password",
    //webAuthResponseType: "code" //(string, default: 'openid', code, 'id_token token')
};

export const METADATA_OIDC = {
    issuer: apiURLs.metadataOIDC,
    jwks_uri: apiURLs.metadataOIDC + "/v1/jwks.json",
    authorization_endpoint: apiURLs.metadataOIDC + (configuration?.authEndpoints?.trustBuilderAuthorizePath || "/v1/authorize"),
    token_endpoint: apiURLs.tpstsvc + "/v2/auth/generate",
    userinfo_endpoint: apiURLs.metadataOIDC + "/v1/userinfo",
    end_session_endpoint: apiURLs.metadataOIDC + "/v1/logout",    
    revocation_endpoint: apiURLs.metadataOIDC + "/v1/revocation",
    introspection_endpoint: apiURLs.tpstsvc + "/api/v1/introspect"
};